import React, { useState, useEffect } from 'react';
import { fetchAudios } from '../../services/api';
import 'bootstrap/dist/css/bootstrap.min.css';

const AudioList = () => {
    const [audios, setAudios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [playingIndex, setPlayingIndex] = useState(null);

    // FULLSCREEN STATE (ONLY FOR BUTTON)
    const [showModal, setShowModal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const getAudios = async () => {
            try {
                const fetchedAudios = await fetchAudios('en');
                const publishedAudios = fetchedAudios
                    .filter(a => a.status === 1)
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

                setAudios(publishedAudios);

            } catch {
                setError('Failed to fetch audios');
            } finally {
                setLoading(false);
            }
        };
        getAudios();
    }, []);

    const extractAudioIframe = (html) => {
        const match = html.match(/<iframe[^>]*src="([^"]+)"/);
        return match ? match[1] : null;
    };

    const openFullscreen = (index = 0) => {
        setCurrentIndex(index);
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    const prevAudio = () =>
        setCurrentIndex((currentIndex - 1 + audios.length) % audios.length);

    const nextAudio = () =>
        setCurrentIndex((currentIndex + 1) % audios.length);

    if (loading) return <div>Loading audios…</div>;
    if (error) return <div>{error}</div>;

    return (
        <div className="audio-list mt-5">
         <h2 className="mb-5 fw-bold">| Podcast Episodes</h2>

            <div className="d-flex flex-column gap-2 mt-3">
                {audios.slice(0, 5).map((audio, idx) => {
                    const iframeSrc = extractAudioIframe(audio.description);

                    return (
                        <div
                            key={audio.id}
                            className="d-flex align-items-center p-2 rounded audio-row"
                            onClick={() => setPlayingIndex(idx)}
                            style={{ cursor: 'pointer', background: '#f8f8f8' }}
                        >
                            {/* Thumbnail */}
                            <div
                                style={{
                                    width: 60,
                                    height: 60,
                                    background: '#ddd',
                                    borderRadius: 4,
                                    marginRight: 12,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 20
                                }}
                            >
                                ▶
                            </div>

                            {/* Title + inline player */}
                            <div style={{ flex: 1 }}>
                                <div className="fw-bold">{audio.title}</div>

                                {playingIndex === idx && iframeSrc && (
                                    <iframe
                                        src={iframeSrc}
                                        width="100%"
                                        height="50"
                                        frameBorder="0"
                                        allow="autoplay"
                                        title={audio.title}
                                    />
                                )}
                            </div>
                        </div>
                    );
                })}

                {/* 6th item — OPENS FULLSCREEN */}
                {audios.length > 5 && (
                    <button
                        className="btn btn-outline-dark w-100 mt-2 fw-bold"
                        onClick={() => openFullscreen(0)}
                    >
                        Listen to More Audio Clips
                    </button>
                )}
            </div>

            {/* FULLSCREEN AUDIO PLAYER */}
            {showModal && (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.9)',
                        zIndex: 1050,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {/* Close */}
                    <button
                        onClick={closeModal}
                        style={{
                            position: 'absolute',
                            top: 20,
                            right: 20,
                            fontSize: 40,
                            color: '#fff',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        ×
                    </button>

                    {/* Left */}
                    <button
                        onClick={prevAudio}
                        style={{
                            position: 'absolute',
                            left: 20,
                            fontSize: 80,
                            color: '#fff',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        ‹
                    </button>

                    {/* Right */}
                    <button
                        onClick={nextAudio}
                        style={{
                            position: 'absolute',
                            right: 20,
                            fontSize: 80,
                            color: '#fff',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        ›
                    </button>

                    {/* Player */}
                    <div style={{ width: '80%', maxWidth: 700, textAlign: 'center' }}>
                        <h3 className="text-white mb-3">
                            {audios[currentIndex].title}
                        </h3>
                        <iframe
                            src={extractAudioIframe(audios[currentIndex].description)}
                            width="100%"
                            height="200"
                            frameBorder="0"
                            allow="autoplay"
                            title={audios[currentIndex].title}
                        />
                    </div>
                </div>
            )}

            <style>{`
                .audio-row:hover {
                    background: #ececec;
                }
            `}</style>
        </div>
    );
};

export default AudioList;


